<template>
  <div class="albums-list">
    <router-link
      tag="md-button"
      :to="{ name: 'profile-albums-new' }">
      add new album
    </router-link>

    <UiDataBox :loading="loading" :isEmpty="isEmpty" :error="error">
      <table class="table-list">
        <thead class="header">
          <th>title</th>
          <th>created date</th>
          <th>event date</th>
        </thead>

        <tr class="item" v-for="item in albums" :key="item.id">
          <td class="title">
            <router-link :to="{ name:'profile-album-edit', params:{id: item.id} }">{{ item.title }}</router-link>
          </td>
          <td>
            {{ $moment(item.created_at).format($FORMAT_DATETIME.DATETIME) }}
          </td>
          <td>
            <span v-if="item.event_date">{{ $moment(item.event_date).format($FORMAT_DATETIME.DATETIME) }}</span>
          </td>
        </tr>
      </table>

      <Pagination
        :total="pagination.total"
        :limit="pagination.limit"
        :page.sync="pagination.page">
      </Pagination>
    </UiDataBox>
  </div>
</template>

<script>
  import * as albumsService from '../../services/albums.service'

  import prepareFetchParamsMixin from '../../mixins/prepareFetchParamsMixin'
  import Pagination from '../../components/Pagination.vue'

  export default {
    name: 'AlbumsList',
    props: {
      limit: {
        type: Number,
        default: 10 // TODO add API support
      },
      page: {
        type: Number,
        default: 0
      }
    },

    mixins: [prepareFetchParamsMixin],

    components: {
      Pagination
    },

    watch: {
      'pagination.page': 'fetchData'
    },

    data () {
      return {
        loading: false,
        error: false,
        albums: [],
        pagination: {
          page: this.page,
          limit: this.limit,
          total: 0
        }
      }
    },

    methods: {
      fetchData () {
        this.loading = true
        albumsService.getList(this.fetchParams)
          .then(response => {
            this.albums = response.data.content
            this.pagination.total = response.data.total
          }).catch(error => { this.error = error })
          .finally(() => { this.loading = false })
      }
    },

    computed: {
      fetchParams () {
        const pagination = this.prepareFetchParamsMixin({
          page: this.pagination.page,
          limit: this.pagination.limit
        })

        return { ...pagination }
      },
      isEmpty () {
        return !this.albums.length
      }
    },

    mounted () {
      this.fetchData()
    }
  }
</script>

<style lang="scss">
  .albums-list {
    height: 100%;

    .table-list {
      width: 100%;
      text-align: left;
    }

    .header {
      font-weight: bold;
      text-transform: uppercase;
      background-color: $color-gray-middle;
      th {
        padding: 15px 0;
      }
    }

    .item {
      border-bottom: 1px solid $color-body;
      .title {
        padding-left: 5px;
      }
      td {
        padding: 10px 0;
      }
      &:hover {
        background-color: #575757;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/profile/AlbumsList.vue